// extracted by mini-css-extract-plugin
export default {"container":"ForgetPage_container__wSa8Y","box":"ForgetPage_box__fqn9z","input":"ForgetPage_input__4fSRX"};